import { render, staticRenderFns } from "./PromotionsBrandEquity.vue?vue&type=template&id=f9fbf60a&scoped=true&"
import script from "./PromotionsBrandEquity.vue?vue&type=script&lang=ts&"
export * from "./PromotionsBrandEquity.vue?vue&type=script&lang=ts&"
import style0 from "./PromotionsBrandEquity.vue?vue&type=style&index=0&id=f9fbf60a&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9fbf60a",
  null
  
)

export default component.exports